import { clearAllActivityListState } from '../utils/activityFiltersStorage';

/**
 * Auth service for handling Google OAuth authentication with Spring Security
 * Uses session cookies - no manual token management needed!
 */
class AuthService {
  /**
   * Initiate Google OAuth login via Spring Security
   * Redirects to backend OAuth2 endpoint
   */
  loginWithGoogle(): void {
    // Goes through Vite proxy → backend OAuth2 endpoint
    window.location.href = '/oauth2/authorization/google';
  }

  /**
   * Check if user is authenticated by calling backend
   * Session cookie is automatically sent
   */
  async isAuthenticated(): Promise<boolean> {
    try {
      // Try to call a protected endpoint (goes through Vite proxy)
      const response = await fetch('/api/v1/auth/health', {
        credentials: 'include' // Send session cookie
      });
      return response.ok;
    } catch {
      return false;
    }
  }

  /**
   * Logout - call backend logout endpoint
   */
  async logout(): Promise<void> {
    try {
      // Avoid following Spring Security's backend redirect to /login?logout.
      await fetch('/logout', {
        method: 'POST',
        credentials: 'include',
        redirect: 'manual',
      });
    } finally {
      clearAllActivityListState();
      window.location.href = '/login?logout';
    }
  }
}

export default new AuthService();
